export default __webpack_public_path__ + "static/media/002-wizard.ffad3795.svg";